<div class="questionnaire-grade-wrap">
  <ul class="questionnaire-grade-score" id="starWrap">
    <li *ngFor="let item of afterQuestionnaireScoreArray;let i = index" class="fa fa-star star-{{i}}" (click)="giveMark(i)"></li>
  </ul>
</div>



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaire-grade/questionnaire-grade.component.html